/**
 * @generated SignedSource<<9a319c0707018d2e3af77a3f6ef883c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateForumInput = {
  description?: string | null | undefined;
  guidelines?: string | null | undefined;
  icon?: any | null | undefined;
  orderingPriority?: number | null | undefined;
  shortDescription: string;
  slug: string;
  title: string;
};
export type ForumCreatePageMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateForumInput;
};
export type ForumCreatePageMutation$data = {
  readonly createForum: {
    readonly node: {
      readonly guidelines: string | null | undefined;
      readonly icon: any | null | undefined;
      readonly id: string;
      readonly orderingPriority: number;
      readonly shortDescription: string;
      readonly slug: string;
      readonly title: string;
    };
  };
};
export type ForumCreatePageMutation = {
  response: ForumCreatePageMutation$data;
  variables: ForumCreatePageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": (v2/*: any*/),
  "concreteType": "ForumEdge",
  "kind": "LinkedField",
  "name": "createForum",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Forum",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shortDescription",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "guidelines",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "icon",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "orderingPriority",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ForumCreatePageMutation",
    "selections": [
      (v3/*: any*/)
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ForumCreatePageMutation",
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": null,
        "handle": "prependEdge",
        "key": "",
        "kind": "LinkedHandle",
        "name": "createForum",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "5665140a13408c753e34b73a45cb310b",
    "id": null,
    "metadata": {},
    "name": "ForumCreatePageMutation",
    "operationKind": "mutation",
    "text": "mutation ForumCreatePageMutation(\n  $input: CreateForumInput!\n) {\n  createForum(input: $input) {\n    node {\n      id\n      title\n      shortDescription\n      guidelines\n      slug\n      icon\n      orderingPriority\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "49f7c4c5720fe71c8482008bdde50406";

export default node;
